module.exports = __webpack_public_path__ + "img/q_32_sor.15ca8713.png";